var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26002_953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 14.6667C8.73341 14.6667 9.33341 14.0667 9.33341 13.3333H6.66675C6.66675 14.0667 7.26675 14.6667 8.00008 14.6667Z",
    fill: "#9D9DE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 12.6667H9.99992C10.3666 12.6667 10.6666 12.3667 10.6666 12C10.6666 11.6333 10.3666 11.3333 9.99992 11.3333H5.99992C5.63325 11.3333 5.33325 11.6333 5.33325 12C5.33325 12.3667 5.63325 12.6667 5.99992 12.6667Z",
    fill: "#9D9DE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33333C5.24 1.33333 3 3.57333 3 6.33333C3 8.87999 4.77333 10.24 5.51333 10.6667H10.4867C11.2267 10.24 13 8.87999 13 6.33333C13 3.57333 10.76 1.33333 8 1.33333Z",
    fill: "#9D9DE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26002_953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardIcon);
export default __webpack_public_path__ + "static/media/standard-icon.3405ae0f.svg";
export { ForwardRef as ReactComponent };